import { Component, Input } from '@angular/core';

import { HelperService, DataService, DateService } from 'app/services';
@Component({
  selector: 'app-estimate-appointment',
  templateUrl: './estimate-appointment.component.html',
  styleUrls: ['./estimate-appointment.component.scss'],
})
export class EstimateAppointmentComponent {
  @Input() estimate: any = {};
  @Input() appointments: any[] = [];
  @Input() vehicles: any[] = [];
  @Input() isArchived: boolean;
  @Input() currentLang: string = 'en';
  archiveStatus: boolean = false;

  constructor(public helperService: HelperService, private dataService: DataService, public dateService: DateService) {}

  /** Create Appointment */
  createAppointment() {
    if (this.estimate.customer && !this.estimate.customer.customerId) {
      this.helperService.showToaster('error', 'Please select customer');
      return;
    }

    const estimate = {
      currentLang : this.currentLang,
      title: `${this.estimate.code} ${this.estimate.title}`,
      vehicle: this.estimate.vehicle || {},
      vehicles: this.vehicles || [],
      followUpCampaign: this.estimate.followUpCampaign,
      estimate: {
        title: this.estimate.title,
        code: this.estimate.code,
        estimateId: {
          _id: this.estimate._id,
          title: this.estimate.title,
          code: this.estimate.code,
        },
      },
      customer: {
        ...this.estimate.customer,
        fullNameQBO: this.estimate.customer.displayName,
        _id: this.estimate.customer.customerId,
        contactOnPhone: this.estimate.customer.isSMS,
        contactOnEmail: this.estimate.customer.isEmail,
      },
    };
    
    const dialogTypeData = this.dataService.typeDialog('add-appointment', 'estimate', null, null, estimate);
    this.dataService.sendData(dialogTypeData);
  }

  /** Edit Appointment */
  editAppointment(appointment: any) {
    const appointmentId = appointment._id;

    this.dataService.sendData(this.dataService.typeDialog('add-appointment', 'calendar-view', appointmentId, null, appointment));
  }
}
